<template>
  <div
    class="c-error-full-screen bg-base color-primary"
    :class="{
      'w-screen': !fitParent,
      'w-full h-full': fitParent,
    }"
  >
    <div
      class="flex flex-col items-center justify-center gap-2 m-auto text-center max-w[400px] px-4"
      :class="{
        'h-screen': !fitParent,
        'h-full': fitParent,
      }"
    >
      <CIcon
        v-if="icon"
        class="mb-2"
        :color="iconColor || themeVars.primary"
        :fa-type="iconType"
        :icon="icon"
        :size="iconSize"
      />
      <h1
        class="ma-0 text-2xl font-light"
        :style="{ color: titleColor || themeVars.primary, fontSize: titleSize ? `${titleSize}px` : undefined }"
      >
        {{ title }}
      </h1>
      <p v-if="description" class="ma-0" :style="{ color: themeVars.primary3 }">
        {{ description }}
      </p>
      <slot />
    </div>
  </div>
</template>
<script lang="ts" setup>
import CIcon from '@lib/components/CIcon/CIcon.vue'
import useThemeVars from '@lib/composables/useThemeVars'
import type { FontAwesomeType } from '@canvas-builder/types/font-awesome.types'

withDefaults(
  defineProps<{
    description?: string
    fitParent?: boolean
    icon?: string
    iconColor?: string
    iconSize?: number
    iconType?: FontAwesomeType
    title: string
    titleColor?: string
    titleSize?: number
  }>(),
  {
    description: '',
    fitParent: false,
    icon: '',
    iconColor: '',
    iconSize: 36,
    iconType: 'far',
    titleColor: '',
    titleSize: undefined,
  },
)

const themeVars = useThemeVars()
</script>
